// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Sora', 'Sora Fallback'","fontStyle":"normal"},"className":"__className_ce197d","variable":"__variable_ce197d"};